import React, { ReactNode } from "react";

export const Segment = ({ children, name }: { children: ReactNode; name?: string }) => {
    return <>{children}</>;
};

export const AntiSection = ({ children }: { children: ReactNode }) => {
    return (
        <div className="-mx-[40px] 2xl:-mx-[max(0px,calc((100vw-1300px+65px)/2))]">{children}</div>
    );
};

export const Section = ({
    className,
    outerClassName,
    children,
    insetTop,
    insetBottom,
    hideOverflowLeft,
    gray,
    relative = true,
    twOverflow = "overflow-hidden",
    ...props
}: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    outerClassName?: string;
    insetTop?: boolean;
    insetBottom?: boolean;
    hideOverflowLeft?: boolean;
    gray?: boolean;
    relative?: boolean;
    twOverflow?: string;
}) => {
    return (
        <div
            className={`w-full
                ${outerClassName} ${gray && "bg-zinc-100 print:bg-white"} 
                flex flex-col items-center relative
                ${twOverflow}
            `}
        >
            {insetTop && (
                <div className="print:hidden shadow-lg z-[11] w-full h-7 -mt-7 col-span-full" />
            )}
            <div
                className={`w-full max-w-[1300px] px-5 lg:px-10 print:px-10 ${
                    relative && "relative"
                } ${className}`}
                {...props}
            >
                {hideOverflowLeft && (
                    <div className="absolute ml-10 left-[-299px] w-[300px] h-full bg-gray-50 print:bg-white z-10 border-r border-dashed" />
                )}
                {children}
            </div>
            {insetBottom && (
                <div className="z-[11] shadow-lg print:hidden w-full h-7 -mb-7 rotate-180 col-span-full" />
            )}
        </div>
    );
};
